import { FC, PropsWithChildren, useEffect } from 'react'

import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react'
import TagManager from 'react-gtm-module'

import { APP } from 'src/Configs/App'
import {
  getUserCreatedAt,
  getUserId,
} from 'src/Redux/auth-process/userSlice/selectors'
import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import { getUserCountry } from 'src/Redux/auth-process/countrySlice/api-actions'
import { getCountry } from 'src/Redux/auth-process/countrySlice/selectors'

const key = 'sc_gb_sessionId'
const generateSessionId = (): string => {
  const { localStorage } = window
  const now = String(Date.now())
  const session = localStorage.getItem(key)
  if (session) {
    return session
  }
  localStorage.setItem(key, now)
  return now
}

const growthBook = new GrowthBook({
  apiHost: APP.GROWTHBOOK_API_HOST,
  clientKey: APP.GROWTHBOOK_CLIENT_KEY,
  enableDevMode: APP.ENABLED_DEV_MODE_GROWTHBOOK,
  trackingCallback: (experiment, result) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'first_ab_test',
        experiment_id: experiment.key,
        variation_id: result.variationId,
        user_id: result.hashValue,
      },
    })
  },
})

export const GrowthProvider: FC<PropsWithChildren> = ({ children }) => {
  const userId = useAppSelector(getUserId)
  const createdAt = useAppSelector(getUserCreatedAt)
  const dispatch = useAppDispatch()
  const country = useAppSelector(getCountry)

  useEffect(() => {
    void growthBook.init()
    void dispatch(getUserCountry())
  }, [dispatch])

  useEffect(() => {
    void growthBook.setAttributes({
      id: userId || generateSessionId(),
      country,
      createdAt,
    })
  }, [userId, country, createdAt])
  return (
    <GrowthBookProvider growthbook={growthBook}>{children}</GrowthBookProvider>
  )
}
